// @flow

import { styled } from "@material-ui/core/styles"

export const PaperContainer = styled("div")({
  margin: 16,
  padding: 16,
  border: "1px solid #ccc",
  borderRadius: 4,
  boxShadow: "0px 2px 2px rgba(0,0,0,0.1)",
})

export default PaperContainer
